module.exports = __webpack_public_path__ + "static/img/greatwall.af06253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/greatwall.jpg
// module id = FHVA
// module chunks = 1